import { Howl, Howler } from "howler"

import { qs } from './utils'

import gsap from 'gsap'
import SiriWave from 'siriwave'

const resources = [
  {
    name: 'underwater',
    src: '/app/themes/rewild-yourself/dist/sounds/underwater.aac'
  },

  {
    name: 'soundtrack',
    src: '/app/themes/rewild-yourself/dist/sounds/soundtrack.mp3'
  }
]

export class Sound {
  constructor() {
  }

  init() {
    this.resources = {}
    this.muted = true
    this.animating = false
    this.toggle = qs('[data-sound-toggle]')

    resources.forEach(res => {
      this.resources[res.name] = new Howl({
        src: [res.src],
        loop: res.name === 'soundtrack' ? true : false
      })
    })

    Howler.volume(0)

    this.toggleMute = this.toggleMute.bind(this)
    this.toggle.addEventListener('click', this.toggleMute)

    window.addEventListener('blur', () => {
      Howler.volume(0)
      this.siriwave.setAmplitude(0)
    })

    window.addEventListener('focus', () => {
      if (!this.muted) {
        Howler.volume(1)
        this.siriwave.setAmplitude(1)
      }
    })

    this.createSiriwave()
  }

  createSiriwave() {
    this.siriwave = new SiriWave({
      container: this.toggle,
      frequency: 3,
      amplitude: 0,
      width: 24,
      height: 40,
      speed: 0.04,
      color: '#fff',
      autoStart: true,
      curveDefinition: [
        {
          attenuation: 1,
          lineWidth: 2 * window.devicePixelRatio,
          opacity: 1,
        },
      ]
    })
  }

  mute() {
    if (this.animating) return

    const wave = this.siriwave

    this.animating = true
    this.muted = true

    const data = { volume: 1 }

    gsap.to(data, {
      volume: 0,
      duration: 0.5,
      onUpdate: function() {
        Howler.volume(data.volume)
        wave?.setAmplitude(data.volume)
      },
      onComplete: () => {
        this.animating = false
      }
    })
  }

  unmute() {
    if (this.animating) return

    const wave = this.siriwave

    this.animating = true
    this.muted = false

    const data = { volume: 0 }

    gsap.to(data, {
      volume: 1,
      duration: 0.5,
      onUpdate: function() {
        Howler.volume(data.volume)
        wave.setAmplitude(data.volume)
      },
      onComplete: () => {
        this.animating = false
      }
    })
  }

  play(id) {
    this.resources[id].play()
  }

  toggleMute() {
    this[this.muted ? 'unmute' : 'mute']()
  }

  destroy() {
    if (!this.muted) {
      this.mute()
    }

    this.toggle.removeEventListener('click', this.bindedFunc)
  }
}

export default new Sound()
